var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3504 18.0015C27.3504 12.8362 23.1648 8.6499 18.0004 8.6499C12.836 8.6499 8.65039 12.8362 8.65039 18.0015C8.65039 22.67 12.069 26.5385 16.5395 27.2399V20.7047H14.1654V18.0015H16.5395V15.9412C16.5395 13.5979 17.9346 12.3029 20.0713 12.3029C21.0939 12.3029 22.1641 12.4855 22.1641 12.4855V14.7869H20.9844C19.8229 14.7869 19.4613 15.5084 19.4613 16.2481V18.0015H22.0545L21.6399 20.7047H19.4613V27.2399C23.9318 26.5385 27.3504 22.67 27.3504 18.0015Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.aed75150f25bab345c501bbd29c7edfc.svg";
export { ForwardRef as ReactComponent };